var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcBackWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.548 19.1389L21.026 12.6479C21.1431 12.5306 21.302 12.4645 21.4678 12.4644C21.6336 12.4642 21.7927 12.5298 21.91 12.6469C22.0274 12.764 22.0934 12.9229 22.0936 13.0887C22.0938 13.2545 22.0281 13.4136 21.911 13.5309L15.433 20.0229C15.316 20.1403 15.2503 20.2992 15.2503 20.4649C15.2503 20.6306 15.316 20.7896 15.433 20.9069L21.911 27.3979C21.969 27.456 22.015 27.525 22.0463 27.6009C22.0776 27.6768 22.0937 27.7581 22.0936 27.8401C22.0935 27.9222 22.0772 28.0035 22.0457 28.0793C22.0142 28.1551 21.9681 28.224 21.91 28.2819C21.8519 28.3399 21.783 28.3859 21.7071 28.4172C21.6312 28.4485 21.5499 28.4646 21.4678 28.4645C21.3857 28.4644 21.3045 28.4482 21.2287 28.4167C21.1529 28.3852 21.084 28.339 21.026 28.2809L14.549 21.7899C14.1979 21.4382 14.0007 20.9616 14.0005 20.4646C14.0003 19.9677 14.1972 19.4909 14.548 19.1389V19.1389Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBackWhite);
export default __webpack_public_path__ + "static/media/ic-back-white.b5069154ccc26c56cd3e3bc98aba88d1.svg";
export { ForwardRef as ReactComponent };